import { AnimatePresence, motion } from "framer-motion";
import type { ReactNode, CSSProperties, ComponentProps } from "react";

export interface FadeTransitionProps {
  show: boolean;
  children: ReactNode;
  duration?: number;
  className?: string;
  style?: CSSProperties;
  "data-testid"?: string;
  mode?: ComponentProps<typeof AnimatePresence>["mode"];
  /* If true, the transition container will take the full width and height of its parent */
  fitParent?: boolean;
}

const FadeTransition = ({
  show,
  children,
  duration = 0.3,
  className,
  style,
  "data-testid": dataTestId,
  mode = "sync",
  fitParent = false
}: FadeTransitionProps) => {
  const fitParentStyle = fitParent
    ? {
        width: "100%",
        height: "100%"
      }
    : {};
  return (
    <AnimatePresence mode={mode}>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration }}
          className={className}
          style={{ ...style, ...fitParentStyle }}
          data-testid={dataTestId ?? "fade-transition"}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FadeTransition;
